export const DISPLAY_DATE_FORMAT = 'MMMM Do, YYYY'
export const DISPLAY_DATE_TIME_FORMAT = 'MMMM Do, YYYY h:mm a'
export const DEFAULT_DATE_FORMAT = 'MM-DD-YYYY'
